import { IconError } from '@zillow/constellation';

type Props = {
  title?: string;
  tabIndex?: number;
  marginRight?: string;
};

const AccordionIconError = ({ title = 'Error', ...rest }: Props) => {
  return (
    <IconError fontColor="yellow600" data-testid="AccordionIconError" {...rest}>
      <title>{title}</title>
    </IconError>
  );
};

export default AccordionIconError;
